import PatternDesignServiceLibrary from '../PatternDesignService/PatternDesignServiceLibrary';
import UserImageLibrary from '../UserData/Resources/UserImageLibrary';

export default class {
	public static UserImageLibrary:UserImageLibrary = new UserImageLibrary();
	public static PatternDesignServiceLibrary:PatternDesignServiceLibrary = new PatternDesignServiceLibrary();

	public static flush() {
		this.UserImageLibrary.flush();
		this.PatternDesignServiceLibrary.flush();
	}
}